import axios from 'axios';

export const getScarvesDataAPI = (onSuccess, onError) => {
    axios
        .get('https://api.mamikonyan.io/scarves/data.json')
        .then(res => {
            onSuccess(res.data);
        })
        .catch(err => {
            onError(err);
        });
};

export const getContributorsDataAPI = (
    onSuccess,
    onError
) => {
    axios
        .get(
            'https://api.mamikonyan.io/scarves/contributors.json'
        )
        .then(res => {
            onSuccess(res.data);
        })
        .catch(err => {
            onError(err);
        });
};
